// app-pages/AboutUs/SignInButton.tsx
"use client";
import { useAppContext } from "hooks";
import { useDisclosure, Show } from "@chakra-ui/react";
import { GoogleForm } from "components";

export default function SignInButton() {
  const { jwt } = useAppContext();
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (jwt) {
    return <></>;
  }

  return (
    <>
      {/* Mobile, < 768px */}
      <Show below="md-1">
        <button
          onClick={onOpen}
          className="mt-7 rounded-lg py-4 text-white bg-blue-500 hover:opacity-90 w-full"
        >
          Start Creating for Free
        </button>
      </Show>
      {/* Desktop, >= 768px */}
      <Show above="md">
        <button
          onClick={onOpen}
          className="bg-blue-500 text-white p-4 h-14 rounded-lg hover:opacity-90"
          style={{ maxWidth: "225px" }}
        >
          Start Creating for Free
        </button>
      </Show>
      <GoogleForm onClose={onClose} isOpen={isOpen} />
    </>
  );
}
